import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSort, Sort } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { ICategory } from 'src/app/core/models/category.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { UserService } from 'src/app/core/services/user.service';
import { FileStatus } from 'src/app/shared/enums/file-status.enum';
import * as XLSX from 'xlsx';
import { ConstantService } from 'src/app/core/services/constant.service';
import { ISaleOrder } from 'src/app/modules/sales-order-management/models/sale-order.interface';
import { SaleOrderInvoiceType } from 'src/app/shared/enums/sale-order-invoice-type.enum';
import { ICountry } from 'src/app/core/models/country.interface';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

const Field_List_Value: any =
{
  reorder: false,
  eciOrderDate: false,
  orderId: false,
  stripeAmount: false,
  stripeRefundAmount: false,
  marketplaceVat: false,
};
@Component({
  selector: 'eci-table-marketplace-sales-order',
  templateUrl: './table-marketplace-sales-order.component.html',
  styleUrls: ['./table-marketplace-sales-order.component.scss']
})
export class TableMarketplaceSalesOrderComponent implements OnInit, OnChanges {

  constructor(
    private router: Router,
    public userSvc: UserService,
    public uploadFileSvc: UploadFileService,
    private datePipe: DatePipe,
    private constSvc: ConstantService,
    public route: ActivatedRoute,
    private consolidateShipmentService: ConsolidateShipmentService,
    private localStorageSvc: LocalStorageService
  ) { }

  @Input() dataSource;
  @Input() displayedColumns;
  @Input() availableCategories: ICategory[];
  @Input() availableTypes: IAvailableTypes;
  @Input() sumOfTotalFIelds: any[];
  @Input() showConsolidateBtn: boolean = false;
  @Input() sumOfTotalFIeldsIncludingCancelled: any[];
  @Input() showDownloadBtn: boolean = true;
  @Input() pageParams: PageParams = new PageParams();
  @Input() listOfSelectedItems: number[] = [];
  @Input() countries: ICountry[] = [];
  @Input() listOfSelectedItemsBody: ISaleOrder[] = []; // TO DO NEED TO COMBINE WITH SELECTED ITTEMS
  @Output() listOfSelectedItemsChange: EventEmitter<number[]> = new EventEmitter<number[]>(null);
  @Output() listOfSelectedItemsBodyChange: EventEmitter<ISaleOrder[]> = new EventEmitter<ISaleOrder[]>(null);  // TO DO NEED TO COMBINE WITH SELECTED ITTEMS
  @Output() pageChange: EventEmitter<PageParams> = new EventEmitter<PageParams>(null);
  @Output() editProducts: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() downInvoice: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() sortRows: EventEmitter<Sort> = new EventEmitter<Sort>(null);
  @Output() consolidateShipments: EventEmitter<any> = new EventEmitter<any>(null);
  @Output() showEditPopup: EventEmitter<any> = new EventEmitter<boolean>(false);
  @Output() documentSave: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() documentUpload: EventEmitter<{ id: number, e: any, file: any }> = new EventEmitter<{ id: number, e: any, file: any }>(null);
  @Output() documentDelete: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() exportSalesToExcel: EventEmitter<any> = new EventEmitter<any>(null);

  @Output() documentSaveElement: EventEmitter<number> = new EventEmitter<number>(null);
  @Output() documentUploadElement: EventEmitter<any> = new EventEmitter<any>(null);
  @Output() addNewSO: EventEmitter<any> = new EventEmitter<any>(null);


  hiddenFieldList = Field_List_Value;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('table', { static: true, read: ElementRef }) table: ElementRef;

  public is4ConsolShipment: boolean = false;
  consolShipmentId: any;
  addSO: boolean = false;

  OrderStatusCancelled: number;
  OrderStatusShipmentCancelled: number;

  get documentFileTypes(): string[] {
    return [...this.uploadFileSvc.textFileFormats, ...this.uploadFileSvc.fileFormats]
  }

  pageChanged(e): void {
    this.pageChange.emit(e);
    this.table.nativeElement.scrollIntoView();
  }

  ngOnInit(): void {
    this.setReturnsColumns();

    this.route.queryParams.subscribe(vals => {
      if (vals.consolShipment && Number(vals.consolShipment) === 1) {
        this.is4ConsolShipment = true;
      }
      if (vals['id'] && vals['addSO']) {
        this.consolShipmentId = vals['id'];
        this.addSO = vals['addSO'];
      }
    });

    this.callHiddenFields();
    this.userSvc.hiddenFieldMPEvent.subscribe((res) => {
      if (res !== null) {
        this.callHiddenFields();
      }
    });

    if (this.consolShipmentId && this.addSO) {
      this.getConsolShipmentDetails(this.consolShipmentId);
    }
  }

  callHiddenFields() {
    if (this.isAdmin) {
      let fieldListShow = this.localStorageSvc.get('B2B_SALES_ORDER_VISIBLITY_FIELD_RULE') || '';
      if (!fieldListShow) {
        this.constSvc
          .getSettingsDetails('B2B_SALES_ORDER_VISIBLITY_FIELD_RULE')
          .subscribe((data) => {
            if (data.value) {
              let fields = JSON.parse(data.value);
              fields.map((field) => {
                this.hiddenFieldList[field.key] = field.value;
              });
            }
          });
      } else {
        fieldListShow.map((field) => {
          this.hiddenFieldList[field.key] = field.value;
        });
      }
    }
  }

  navigateTo(order): void {
    if (order?.isDraft) {
      this.showEditPopup.emit(order);
    } else {
      this.router.navigate([])
        .then((result) => {
          window.open(`sales-order-management/order-details/${order.id}`, '_blank');
        });
    }
  }

  navigateToShipment(order): void {
    if (order?.isDraft) {
      this.showEditPopup.emit(order);
    } else {
      if (!order?.shipment?.id) {
        return;
      }
      this.router.navigate([]).then((result) => {
        window.open(`customers-order/order-details/${order?.shipment?.id}`, '_blank');
      });
    }
  }

  navigateToConsolDetails(consolNumber): void {
    this.router.navigate([]).then(result => { window.open(`/consolidate-shipments/consol-shipment-details/${consolNumber}`, '_blank'); });
  }

  findCategoryName(id): string {
    if (!this.availableCategories) return;
    const category = this.availableCategories.find(el => el.id == id);
    return category ? category.name : '';
  }

  downloadInvoice(id): void {
    this.downInvoice.emit(id);
  }

  sortData(e: Sort): void {
    this.sortRows.emit(e);
  }

  get hideCol(): boolean {
    return this.userSvc.isDelicated;
  }

  exportToExcel(sheetName: string = 'SheetJS') {
    let ws: XLSX.WorkSheet;
    ws = XLSX.utils.table_to_sheet(this.table.nativeElement, { cellStyles: true, });

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, sheetName + '.xlsx', { cellStyles: true, bookSST: true });
  }

  get isAdmin(): boolean {
    return this.userSvc.isAdmin;
  }

  get fieldList(): any {
    return this.hiddenFieldList;
  }

  get isDelegateAdmin(): boolean {
    return this.userSvc.isDelegatedAdmin;
  }

  get isAllSelected(): boolean {
    return (
      this.listOfSelectedItems?.length > 0 &&
      this.listOfSelectedItems.filter((obj, index) => {
          return this.dataSource.findIndex((o) => obj == o.id) !== -1
      })?.length === this.dataSource?.length
    );
  }
  clearSelection() {
    this.listOfSelectedItems =[];
    this.listOfSelectedItemsBody = [];
    this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
    this.listOfSelectedItemsBodyChange.emit(this.listOfSelectedItemsBody);
  }

  isChecked(id: number): boolean {
    return !!this.listOfSelectedItems.find(el => el === id);
  }

  isCancelNote(id: number): boolean {
    return this.dataSource.find(el => el.id === id)?.type === SaleOrderInvoiceType.CANCEL_NOTE;
  }

  selectAllChanged(event: MatCheckboxChange): void {
    if (event.checked) {
      this.listOfSelectedItems = this.dataSource.map((el) => {
        if (!el.isDraft) {
          return el.id;
        }
      });
    } else {
      this.listOfSelectedItems = [];
    }
    this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
  }

  selectionChanged(event: MatCheckboxChange, item): void {
    if (event.checked) {
      if (!this.isChecked(item.id)) {
        this.listOfSelectedItems.push(item.id);
        this.listOfSelectedItemsBody.push(item);
      }
    } else {
      if (this.isChecked(item.id)) {
        this.listOfSelectedItems.splice(this.listOfSelectedItems.findIndex(el => el === item.id), 1);
        this.listOfSelectedItemsBody.splice(this.listOfSelectedItems.findIndex(el => el === item.id), 1);
      } else {
          this.listOfSelectedItems = this.listOfSelectedItems.filter(id => id !== item.id);
      }
    }
    this.listOfSelectedItemsChange.emit(this.listOfSelectedItems);
    this.listOfSelectedItemsBodyChange.emit(this.listOfSelectedItemsBody);
  }

  getTotalVat(element): string {
    return (parseFloat(element?.eciVat || 0) || 0).toFixed(2);
    //return ((parseFloat(element?.eciVat || 0) + parseFloat(element?.shipmentVat || 0)) || 0).toFixed(2)
  }

  devideValue(value1, value2): string {
    return ((parseFloat(value1 || 0) / parseFloat(value2 || 0)) || 0).toFixed(2)
  }

  getMarketPlaceVAT(element): any {
    const marketplaceName = element?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name || '';
    const vatCharges = Number(element?.marketplace?.vatCharges || 0);
    return vatCharges == 0.1 && marketplaceName === 'wix' ? 'Not Available' : vatCharges?.toFixed(2);
  }

  getRate(prod: any): string {
    if (!prod?.vatRate) return null;

    return (prod?.vatRate / prod?.price).toFixed(2);
  }

  dateConvert(date: any): string {
    if (!date) return null;
    return this.datePipe.transform(new Date(date).toISOString().slice(0, 16), 'dd/MM/yyyy');
  }

  navigateToErrors(marketplaceOrderId): void {
    if (!marketplaceOrderId) return;

    this.router.navigateByUrl(`/sale-order-errors?orderId=${marketplaceOrderId}`);
  }

  uploadShow(status: number): boolean {
    return status == FileStatus.PENDING;
  }

  downloadShow(status: number): boolean {
    return status == FileStatus.UPLOADED;
  }

  uploadFile(e, file, id): void {
    this.documentUpload.emit({ id: id, e: e, file: file });
  }

  downloadFile(id): void {
    this.documentSave.emit(id);
  }

  deleteDoc(id): void {
    this.documentDelete.emit(id);
  }

  getTableRowColor(row: any): string {
    switch (true) {
      case row?.isDraft: return 'lightgreen';
      case row?.hasReorder && (this.isAdmin || this.isDelegateAdmin): return 'bisquit';
      case row?.isDuplicateOrder: return 'gray';
      case row?.hasDuplicate: return 'duplicate';
      default: ''
    }
  }

  public sum(key: string, key2: string = "") {
    let toalValue = 0;
    if (this.dataSource != undefined) {
      toalValue = this.dataSource.reduce(function (total, row) {
        if (key2 != "") {
          return total + ((row[key] > 0 ? parseFloat(row[key]) : 0) || (row[key2] > 0 ? parseFloat(row[key2]) : 0));
        } else if (key == 'getMarketPlaceVAT') {
          let marketplaceName = row?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name || '';
          let vatCharges = Number(row?.marketplace?.vatCharges || 0);
          vatCharges == 0.1 && marketplaceName === 'wix' ? 'Not Available' : vatCharges;
          return total + vatCharges;
        } else if (key == 'getTotalVat') {
          return total + ((parseFloat(row?.eciVat || 0) + parseFloat(row?.shipmentVat || 0)) || 0);
        } else {
          return total + (row[key] > 0 ? parseFloat(row[key]) : 0);
        }
      }, 0);
      return toalValue;
    } else {
      return 0;
    }
  }

  public cancelConsolshipment(): void {
    this.router.navigateByUrl(`/consolidate-shipments`);
  }

  getConsolShipmentDetails(id: any) {
    this.consolidateShipmentService.getShipmentById(id).subscribe((res) => {
      if (res) {
        for (const saleOrder of res?.saleOrders) {
          this.listOfSelectedItems.push(saleOrder?.id);
        }
      }
    });
  }

  consolidateSaleOrders() {
    if (this.consolShipmentId && this.addSO) {
      this.addNewSO.emit(this.consolShipmentId);
    }
    else {
      this.consolidateShipments.emit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['availableTypes'] && changes['availableTypes'].currentValue != null) {
      this.availableTypes = changes['availableTypes'].currentValue;
      this.setReturnsColumns();
    }
  }

  setReturnsColumns() {
    this.OrderStatusCancelled = this.availableTypes ? this.availableTypes.SaleOrderStatus.find(el => el.name === 'CANCELED').id : null;
    this.OrderStatusShipmentCancelled = this.availableTypes ? this.availableTypes.SaleOrderStatus.find(el => el.name === 'SHIPMENT_CANCELED').id : null;
  }

}
